<template>
  <div class="cds-page">
    <div class="search-form">
      <el-form
        inline
        :model="searchData"
      >
        <el-form-item
          label="产品代码"
          prop="prdCode"
        >
          <el-input
            placeholder="请输入"
            v-model.trim="searchData.prdCode"
          />
        </el-form-item>
        <el-form-item
          label="产品名称"
          prop="prdName"
        >
          <el-input
            placeholder="请输入"
            v-model.trim="searchData.prdName"
          />
        </el-form-item>
        <el-form-item
          label="发行开始日"
          prop="subStartDayStart"
          style="margin-right: 12px"
        >
          <el-date-picker
            type="date"
            placeholder="开始日期"
            v-model="searchData.subStartDayStart"
            clearable
            :picker-options="$_yh_before(searchData.subStartDayEnd)"
          />
        </el-form-item>
        <el-form-item
          label="至"
          prop="subStartDayEnd"
        >
          <el-date-picker
            v-model="searchData.subStartDayEnd"
            type="date"
            clearable
            placeholder="结束日期"
            :picker-options="$_yh_after(searchData.subStartDayStart)"
          />
        </el-form-item>
        <el-form-item
          label="产品状态"
          prop="saleStatus"
        >
          <el-select
            v-model="searchData.saleStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in depositPrdStatus"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="存单期限"
          prop="termLimit"
        >
          <el-select
            v-model="searchData.termLimit"
            clearable
          >
            <el-option
              v-for="item in depositPrdTermLimit"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="发行结束日"
          prop="subEndDayStart"
          style="margin-right: 12px;"
        >
          <el-date-picker
            type="date"
            v-model="searchData.subEndDayStart"
            placeholder="开始日期"
            :picker-options="$_yh_before(searchData.subEndDayEnd)"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="至"
          style="margin-right: 12px;"
          prop="subEndDayEnd"
        >
          <el-date-picker
            type="date"
            v-model="searchData.subEndDayEnd"
            :picker-options="$_yh_after(searchData.subEndDayStart)"
            clearable
            placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item
          label="年利率"
          prop="annualInsrateStart"
          style="margin-right: 12px;"
        >
          <el-input
            placeholder="请输入"
            @keyup.native="filterRate(searchData, 'annualInsrateStart')"
            v-model="searchData.annualInsrateStart"
          /> %
        </el-form-item>
        <el-form-item
          label="至"
          prop="annualInsrateEnd"
        >
          <el-input
            placeholder="请输入"
            @keyup.native="filterRate(searchData, 'annualInsrateEnd')"
            v-model="searchData.annualInsrateEnd"
          /> %
        </el-form-item>

        <el-form-item
          label="是否置顶"
          prop="isTop"
        >
          <el-select
            v-model="searchData.isTop"
            clearable
            placeholder="请输入"
          >
            <el-option
              v-for="item in stickStatusList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="上下架状态"
          prop="isSale"
          clearable
          placeholder="请输入"
        >
          <el-select
            v-model="searchData.isSale"
            clearable
          >
            <el-option
              v-for="item in saleStatusList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <section class="flex-between">
      <div>
        <yh-button
          type="primary"
          size="small"
          @click="handleSearchClick"
        >查询</yh-button>
        <el-button
          size="small"
          @click="handleResetClick"
        >清空查询条件</el-button>
      </div>
    </section>

    <el-table
      :class="sortClass"
      :data="tableData"
      @sort-change="handleSortChange"
      ref="table"
      border
    >
      <template slot="empty">
        {{emptyText}}
      </template>
      <el-table-column
        v-for="col in tableLabelList"
        :min-width="col.width"
        :label="col.label"
        :key="col.key"
        :sortable="col.sortable ? 'custom': false"
        :sort-orders="['descending', 'ascending', null]"
        :prop="col.key"
        :formatter="formatter"
      ></el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        min-width="230"
      >
        <template slot-scope="scope">
          <div class="feature-container">
            <span
              v-if="canViewDetail"
              class="button--blue"
              @click="handleDetailClick(scope.row)"
            >产品详情</span>
            <span
              v-if="canUpdateTop"
              class="button--blue"
              @click="confirm(
                computeStickText(scope.row.isTop),
                scope.row.prdName,
                ()=>updateStickStatus(scope.row, updateSuccess, error)
              )"
            >{{computeStickText(scope.row.isTop)}}</span>
            <span
              v-if="canUpdateSale"
              @click="confirm(
                computeSaleText(scope.row.isSale),
                scope.row.prdName,
                ()=>updateSaleStatus(scope.row, updateSuccess, error),
                getConfirmButtonClass(scope.row.isSale)
              )"
              :class="computeSaleClass(scope.row.isSale)"
            >{{computeSaleText(scope.row.isSale)}}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
  </div>
</template>

<script>
import { getPagingData, addNav } from '@/mixins';
import cdsMixin from './mixin';

const { orgnInheritSign, userId, orgnCode } = JSON.parse(sessionStorage.getItem('sessionData'));
const baseData = {
  prdCode: '', // 产品代码
  prdName: '', // 产品名称
  subStartDayStart: '', // 发行开始时间 起
  subStartDayEnd: '', // 发行开始时间 止
  subEndDayStart: '', // 发行结束时间 起
  subEndDayEnd: '', // 发行结束时间 止
  saleStatus: '', // 销售状态 1-在售  2-停售  3-售罄
  termLimit: '', // 存单期限
  annualInsrateStart: '', // 年化利率 起
  annualInsrateEnd: '', // 年化利率 止
  isTop: '', // 是否置顶（1-是，2-否）
  isSale: '', // 上下架状态 (1-上架，2-下架)
  sort: 'updateTime', // 时间参数
  order: 'desc', // 排序顺序
  orgnInheritSign,
  userId,
  orgnCode,
};
export default {
  name: 'CDSList',
  mixins: [getPagingData, cdsMixin, addNav],

  data() {
    return {
      userId,
      functinList: [],
      sortable: true,
      tableData: [],
      sumCount: 0,
      currentPage: 1,
      emptyText: this.$LS.empty,
      productStatus: '',
      cdsExpires: '',
      stickStatus: '',
      saleStatus: '',
      depositPrdStatus: [], // 产品状态
      // ，3个月，6个月，9个月，1年，18个月，2年，3年，5年
      depositPrdTermLimit: [], // 存单期限
      stickStatusList: [{
        label: '是',
        value: '1',
      }, {
        label: '否',
        value: '0',
      }], // 置顶状态
      saleStatusList: [{
        label: '上架',
        value: '1',
      }, {
        label: '下架',
        value: '0',
      }], // 上下架状态
      searchParam: {
        ...baseData,
      },
      searchData: {
        prdCode: '', // 产品代码
        prdName: '', // 产品名称
        subStartDayStart: '', // 发行开始时间 起
        subStartDayEnd: '', // 发行开始时间 止
        subEndDayStart: '', // 发行结束时间 起
        subEndDayEnd: '', // 发行结束时间 止
        saleStatus: '', // 销售状态 1-在售  2-停售  3-售罄
        termLimit: '', // 存单期限
        annualInsrateStart: '', // 年化利率 起
        annualInsrateEnd: '', // 年化利率 止
        isTop: '', // 是否置顶（1-是，2-否）
        isSale: '', // 上下架状态 (1-上架，2-下架),
      }, // 搜索区域数据
      tableLabelList: [{ // table 中的字段
        label: '产品代码',
        key: 'prdCode',
        width: 200,
      }, {
        label: '产品名称',
        key: 'prdName',
        width: 200,
      }, {
        label: '产品状态',
        key: 'saleStatus',
        width: 100,
      }, {
        label: '上下架状态',
        key: 'isSale',
        width: 150,
      }, {
        label: '是否置顶',
        key: 'isTop',
        width: 100,
      }, {
        label: '起存金额(元)',
        key: 'originBuyMoney',
        width: 200,
        sortable: true,
      }, {
        label: '存单期限',
        key: 'termLimit',
        width: 100,
      }, {
        label: '年利率',
        key: 'annualInsrate',
        width: 130,
        sortable: true,
      }, {
        label: '发售总额(元)',
        key: 'saleAmt',
        sortable: true,
        width: 200,
      }, {
        label: '可售余额(元)',
        key: 'remainAmounts',
        sortable: true,
        width: 200,
      }, {
        label: '发行开始日',
        key: 'subStartDay',
        sortable: true,
        width: 200,
      }, {
        label: '发行结束日',
        key: 'subEndDay',
        sortable: true,
        width: 200,
      }, {
        label: '管理信息修改时间',
        key: 'updateTime',
        width: 300,
        sortable: true,
      }, {
        label: '管理信息修改人',
        key: 'updateUserName',
        width: 230,
      }],
    };
  },
  computed: {
    table() {
      return this.$refs.table;
    },
    sortClass() {
      return this.sortable ? '' : 'grey-caret';
    },
  },
  watch: {
    currentPage: {
      immediate: false,
      handler() {
        this.listCDS();
      },
    },
  },
  activated() {
    this.listCDS();
  },
  methods: {
    listCDS() {
      this.getPagingData(this.$API.listCDS);
    },
    filterRate(data, key) {
      // eslint-disable-next-line no-param-reassign
      data[key] = data[key].replace(/[^\d.]/g, '');
      const last = data[key].lastIndexOf('.');
      const first = data[key].indexOf('.');
      if (last !== first) {
        // eslint-disable-next-line no-param-reassign
        data[key] = data[key].slice(0, last) + data[key].slice(last + 1);
      }
    },
    handleSearchClick() {
      this.sortable = false;
      this.searchParam = {
        ...this.searchParam,
        ...this.searchData,
      };
      this.searchParam.sort = 'updateTime';
      this.searchParam.order = 'desc';
      if (this.currentPage === 1) {
        this.listCDS();
      } else {
        this.currentPage = 1;
      }
    },
    handleResetClick() {
      this.sortable = false;
      Object.keys(this.searchData).forEach((key) => {
        this.searchData[key] = '';
      });
      this.searchParam = {
        ...baseData,
      };
    },

    handleSortChange({ prop, order }) {
      this.sortable = true;
      const orderMap = {
        descending: 'desc',
        ascending: 'asc',
      };
      this.searchParam.sort = prop;
      if (!order) {
        this.searchParam.order = orderMap[order] || 'desc';
        this.searchParam.sort = 'updateTime';
      } else {
        this.searchParam.order = orderMap[order];
      }
      if (this.currentPage === 1) {
        this.listCDS();
      } else {
        this.currentPage = 1;
      }
    },
  },
};
</script>
<style lang="scss">
.cds-page {
  .grey-caret {
    .descending .descending {
      border-top-color: #c0c4cc !important;
    }
    .ascending .ascending {
      border-bottom-color: #c0c4cc !important;
    }
  }
  // 特殊需求，金额数据展示靠右
  th:nth-of-type(6),
  th:nth-of-type(9),
  th:nth-of-type(10) {
    text-align: right;
  }
}
.cds-button--red {
  background-color: #f56c6c !important;
  border: 0;
}
.cds-button--green {
  background-color: #67c23a !important;
  border: 0;
}
</style>
